import { createSlice } from "@reduxjs/toolkit";
import {
  getThirdFlow,
  createThirdFlow,
  updateThirdFlow,
  deleteThirdFlow,
  clearLocalActiveThirdFlow
} from './actions';

export const initialState = {
  thirdFlow: { id: '', email: '', prompt: '', updated_at: '' },
  loading: false
};

const slice = createSlice({
  name: 'thirdFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getThirdFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getThirdFlow.fulfilled, (state, action) => {
        const { third_flow } = action.payload;
        const thirdFlow = { ...state.thirdFlow, ...third_flow };
        
        state.loading = false;
        state.thirdFlow = thirdFlow;
      })
      .addCase(getThirdFlow.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createThirdFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createThirdFlow.fulfilled, (state, action) => {
        const { third_flow } = action.payload;
        
        state.loading = false;
        state.thirdFlow = third_flow;       
      })
      .addCase(createThirdFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateThirdFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateThirdFlow.fulfilled, (state, action) => {
        const { status, third_flow } = action.payload;
        const updatedThirdFlow = { ...state.thirdFlow, ...third_flow };
        
        state.loading = false;
        if (status === 204) state.thirdFlow = updatedThirdFlow;       
      })
      .addCase(updateThirdFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteThirdFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteThirdFlow.fulfilled, (state, action) => {
        const { status } = action.payload;
        
        state.loading = false;
        if (status === 204) state.thirdFlow = initialState.thirdFlow;       
      })
      .addCase(deleteThirdFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveThirdFlow, state => {
        state.thirdFlow = initialState.thirdFlow;
      })
  }
})

export default slice.reducer;